import maxLengthFromRegex from './attributeTextLimits';

/**
 * Field map for MobileFocusModal built from the BE-driven textfield
 * attributes (Navnetryk, Speciel tekst, ...). Keyed by attribute slug — the
 * same key the focus trigger passes to `openFocusMode(slug)`.
 *
 * Mirrors what DynamicAttributeControls renders inline: name (+ " *" when
 * required), the anchor value's "+NN,-" add-on tag, subtitle as helper text
 * and the regex-derived hard max length.
 */
export const EMPTY_FOCUS_FIELD = { label: '', placeholder: '', value: '', setValue: () => {} };

const formatAdditionalPrice = (raw) => {
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return undefined;
  return `+${Math.round(n)},-`;
};

export function buildTextfieldFocusFields({ attributes = [], selectedAttributes = {}, onChange, hiddenControlSlugs }) {
  const hidden = hiddenControlSlugs instanceof Set ? hiddenControlSlugs : new Set(hiddenControlSlugs || []);
  const fields = {};
  attributes.forEach((attr) => {
    if (attr.type !== 'textfield' || hidden.has(attr.slug)) return;
    const raw = selectedAttributes[attr.slug];
    fields[attr.slug] = {
      label: attr.is_required ? `${attr.name} *` : attr.name,
      placeholder: attr.name,
      price: formatAdditionalPrice(attr.values?.[0]?.additional_price),
      helperText: attr.subtitle || '',
      maxLength: maxLengthFromRegex(attr.regex) || undefined,
      value: typeof raw === 'string' ? raw : '',
      setValue: (v) => onChange?.(attr.slug, v),
    };
  });
  return fields;
}

export default buildTextfieldFocusFields;
